/* unplugin-vue-components disabled */import { render } from "./SensitiveWordsDialog.vue?vue&type=template&id=33dc1912&scoped=true"
import script from "./SensitiveWordsDialog.vue?vue&type=script&lang=js"
export * from "./SensitiveWordsDialog.vue?vue&type=script&lang=js"

import "./SensitiveWordsDialog.vue?vue&type=style&index=0&id=33dc1912&scoped=true&lang=css"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33dc1912"]])

export default __exports__